import React, { useEffect, useState } from 'react';
import { Table, Button, Modal, notification } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { claimsApi, Claim } from '../apiCalls/claimsApi';

const ClaimsList: React.FC = () => {
  const navigate = useNavigate();
  const [dataSource, setDataSource] = useState<Claim[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [deleting, setDeleting] = useState<string | null>(null);

  useEffect(() => {
    fetchClaims();
  }, []);

  const fetchClaims = async () => {
    setLoading(true);
    const claims = await claimsApi.getClaims();
    setDataSource(claims);
    setLoading(false);
  };

  const handleDelete = async (id: string) => {
    try {
      setDeleting(id);
      await claimsApi.deleteClaim(id);
      notification.success({
        message: 'Claim Deleted',
        description: 'The claim has been successfully removed.',
        duration: 3,
      });
      fetchClaims();
    } catch (error: any) {
      notification.error({
        message: 'Error while deleting',
        description: error.message,
        duration: 5,
      });
    } finally {
      setDeleting(null);
    }
  };

  const showDeleteConfirm = (record: Claim) => {
    Modal.confirm({
      title: 'Are you sure you want to delete this claim?',
      content:
          'If this claim is in use in any product or ingredient, it cannot be removed.',
      okText: 'Yes, Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk() {
        handleDelete(record.id);
      },
    });
  };

  const columns = [
    {
      title: 'Edit',
      key: 'edit',
      fixed: 'left' as const,
      width: 70,
      render: (_: any, record: Claim) => (
          <Button
              onClick={() => {
                navigate(`/edit-claim/${record.id}`);
              }}
              icon={<EditOutlined />}
          />
      ),
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Delete',
      key: 'delete',
      fixed: 'right' as const,
      width: 70,
      render: (_: any, record: Claim) => (
          <Button
              danger
              icon={<DeleteOutlined />}
              onClick={() => showDeleteConfirm(record)}
              loading={deleting === record.id}
          />
      ),
    },
  ];

  return (
      <div style={{ padding: 24 }}>
        <h2>List of Claims</h2>
        <Button
            type="primary"
            onClick={() => navigate('/add-claim')}
            style={{ marginBottom: 16 }}
        >
          Add New Claim
        </Button>
        <Table
            dataSource={dataSource}
            columns={columns}
            rowKey="id"
            loading={loading}
            scroll={{ x: 'max-content' }}
        />
      </div>
  );
};

export default ClaimsList;
